import React from "react";
import Container from "./components/Container";
import Footer from "./components/Footer";
import Header from "./components/Header";

const App = () => {
  return (
    <div role="app">
      <Header />
      <Container />
      <Footer />
    </div>
  );
};

export default App;
